export const colors = {
    midlandRed: "#BF1E2E",
    textAccent: "#4F5264",
    textMain: "#0F0F0F",
    border: "#CCCCCC",
    primary: "#2A3261",
    accent: "#F8F9FA",
    warning: "#FFF2B7",
    textLink: "#2E64B0",
    background: "#FFFFFF",
};
